import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doREQUEST_SKIP,
  doPENDING_REQUEST_DELETE,
  doADHERENCE_PROJECT_PARTICIPANT_MAP_SET,
} from '../state'
import {getToken} from './token_fetcher'
import {checkRequestPending} from './check_pending_request'

export const REQUEST_PROJECT_PARTICIPANT_LIST = 'REQUEST_PROJECT_PARTICIPANT_LIST'
export const doREQUEST_PROJECT_PARTICIPANT_LIST = createDoRequestAction(REQUEST_PROJECT_PARTICIPANT_LIST)

export const requestProjectParticipantListActionCreators = {
  doREQUEST_PROJECT_PARTICIPANT_LIST,
}

export function* requestProjectParticipantList({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectParticipantList')

  const sameRequestPending = yield call(checkRequestPending, REQUEST_PROJECT_PARTICIPANT_LIST, payload)
  if (sameRequestPending === true) {
    return yield put(
      doREQUEST_SKIP({
        fromType: REQUEST_PROJECT_PARTICIPANT_LIST,
        requestId: payload.requestId,
      }),
    )
  }

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_PROJECT_PARTICIPANT_LIST, requestId: payload.requestId}))
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_PARTICIPANT_LIST,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v2/web/project-participant-list`,
    accessToken,
    data: {
      projectId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_PROJECT_PARTICIPANT_LIST, requestId: payload.requestId}))
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_PARTICIPANT_LIST,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v2/web/project-participant-list',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doADHERENCE_PROJECT_PARTICIPANT_MAP_SET({
      projectId,
      ...result.payload,
    }),
  )

  yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_PROJECT_PARTICIPANT_LIST, requestId: payload.requestId}))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_PARTICIPANT_LIST,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectParticipantListSaga() {
  yield takeEvery(REQUEST_PROJECT_PARTICIPANT_LIST, requestProjectParticipantList)
}
